import { useTranslations } from '@fshr/context/i18n-context';
import Link from '../link';
import { forwardRef, ReactNode } from 'react';
import { useTealium } from '@fshr/context/tealium-context';

export type LinkSectionWrapperProps = {
	url?: string;
	propertyOrsCode?: string;
	sku?: string;
	children?: ReactNode;
	datalakeRecoId?: string;
	className?: string;
	onClick?: () => void;
};

export const LinkSectionWrapper = forwardRef<
	HTMLDivElement | HTMLAnchorElement,
	LinkSectionWrapperProps
>(function LinkSectionWrapper(
	{
		url,
		propertyOrsCode,
		sku,
		datalakeRecoId,
		children,
		className = 'w-full cursor-pointer flex flex-row gap-[15px] items-start justify-start',
		onClick,
	},
	ref
) {
	const t = useTranslations();
	const { addToRecommendationsCookie } = useTealium();

	return !url ? (
		<div className={className}>{children ?? null}</div>
	) : (
		<Link
			ref={ref as React.RefObject<HTMLAnchorElement>}
			href={url}
			intent="unstyled"
			className={className}
			aria-label={t('Recommendation')}
			onClick={event => {
				event.preventDefault();

				if (onClick) onClick();
				setTimeout(() => {
					window.location.href = url;
				}, 150);
			}}
		>
			{children ?? null}
		</Link>
	);
});
